export const routeConfig = {
  meta: {
    title: '账单查询',
  },
};
